import { Chip } from '@mui/material';
import { useGetEnvironnementQuery } from '@services/configApi';

interface WorktreeBorderWrapperProps {
  children: React.ReactNode;
}

function WorktreeBorderWrapper({ children }: Readonly<WorktreeBorderWrapperProps>) {
  const { data } = useGetEnvironnementQuery();
  const color = data?.debugInfo?.worktreeColor;
  const name = data?.debugInfo?.worktreeName;

  if (!color) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <Chip
        label={name ?? 'dev'}
        size="small"
        sx={{
          position: 'fixed',
          bottom: 8,
          left: 8,
          backgroundColor: color,
          color: 'common.white',
          fontWeight: 600,
          fontSize: '0.7rem',
          zIndex: 9999,
          px: 2,
        }}
      />
    </>
  );
}

export default WorktreeBorderWrapper;
